import { useMemo } from 'react';
import { getProperty } from '../../../fsConfig';

export interface FeatureVisibility {
  canViewTripStatusApi: boolean;
  showAlertsSent: boolean;
  showEmailsSent: boolean;
  showWaiverMetric: boolean;
}

/**
 * Reads the current user session and returns boolean flags
 * for every conditionally-visible element on the Usage Reporting dashboard.
 * Each flag corresponds to one business rule — when a rule changes, only
 * this hook needs to change.
 */
export function useFeatureVisibility(): FeatureVisibility {
  const user = getProperty('session', {});

  return useMemo(() => {
    const showEmailsSent: boolean =
      user.hasAccountFeature?.('EMAIL_ALERTS') ?? true;
    const showSms: boolean =
      user.hasAccountFeature?.('SMS_NOTIFICATIONS') ?? false;
    const showApiAlerts: boolean =
      user.hasAccountFeature?.('API_ALERTS') ?? false;

    return {
      canViewTripStatusApi: user.hasAccountFeature?.('API_ACCESS') ?? false,
      showAlertsSent: showApiAlerts || showEmailsSent || showSms,
      showEmailsSent,
      showWaiverMetric:
        (user.hasAccountFeature?.('WAIVER_VIEW') ||
          user.hasAccountFeature?.('WAIVER_CREATE_EDIT')) ??
        false,
    };
  }, [user]);
}
